export const SEARCH_TIMEOUT = 500;
export const AMOUNT_OF_PLACEHOLDERS = 5;
export const SEARCH_CHAR_THRESHOLD = 2;
